import Template from 'backbone/story/templates/comments/inline_comment_button.js.hamlc'
import MixpanelEvent from 'utils/platform/mixpanel_event.js'

export default class InlineCommentButtonView extends Backbone.View
  events:
    "click .modal-open" : "trackInvalidSelectionInfoClick"

  initialize: (options) ->
    @options = $.extend({top : 0, enabled : true}, options)

  render: ->
    this.setElement(Template(
      enabled: @options.enabled,
      top: @options.top,
      fetched: @options.fetched
    ))

  trackInvalidSelectionInfoClick: ->
    mixpanelEvent = new MixpanelEvent()
    mixpanelEvent.withStory().track("comment-error-popup-clicked")



// WEBPACK FOOTER //
// ./app/javascript/backbone/story/views/comments/inline_comment_button_view.js.coffee